// import contentful from "contentful";

var contentful = require("contentful");
export const client = contentful.createClient({
  accessToken: "cjQuhd3VGO3nmVRGkDfmyxec93VtND2pu3eP6S2V9nI",
  space: "61fhwxg3uano",
});
